import { 
    Loader, 
    DateField, 
    ModalHeader, 
    ModalNext, 
    ModalBody, 
    ModalFooter 
} from '@jutro/components';
import { Button } from '@jutro/legacy/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { TwiaPolicyService } from 'ent-capability-policybilling';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React, {
    useCallback,
    useEffect,
    useState,
} from 'react';
import metadata from './InstallmentPreviewPopupComponent.metadata.json5';
import styles from './InstallmentPreviewPopupComponent.module.scss';
import messages from './InstallmentPreviewPopupComponent.messages.js';

function InstallmentPreviewPopup(props) {
    const { 
        isOpen, 
        onReject, 
        offer,
        paymentPlan, 
        authHeader } = props;
    const [isLoading, setIsLoading] = useState(false);
    const translator = useTranslator();
    const [installmentsData, setInstallmentsData] = useState();

    useEffect(() => {
        setIsLoading(true);
        TwiaPolicyService.retrieveInstallmentsPreview(offer.jobNumber_TWIA, paymentPlan.billingId, authHeader)
        .then(response => {
            setInstallmentsData(response);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [paymentPlan, authHeader, offer.jobNumber_TWIA]);

    const viewInstallmentName = useCallback((item) => (
        <span>{item.typeDisplay}</span>
    ), []);

    const viewInstallmentDate = useCallback((item, index) => (
        <span id={`dueDate${index}`}>{item.dueDate ? format(new Date(item.dueDate), 'MM/dd/yy') : ''}</span> 
    ), []);

    const viewInstallmentAmount = useCallback((item, index) => (
        <CurrencyField
            id={`downPayment${index}`}
            value={item.amount}
            readOnly
            hideLabel
        />
    ), []);

    const handleClose = useCallback(() => {
        onReject();
    }, [onReject]);

    const overrideProps = {
        installmentsPreviewTable: {
            visible: !_.isUndefined(installmentsData),
            data: installmentsData,
        },
        installmentPreviewTitle: {
            content: translator(messages.selectedPlan, {planName: paymentPlan.name})
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            viewInstallmentName,
            viewInstallmentAmount,
            viewInstallmentDate,
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext 
            isOpen={isOpen}
            className={styles.installmentsModal}>
            <ModalHeader title={translator(messages.title)} />
            <ModalBody>
                <Loader loaded={!isLoading}>
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={installmentsData}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleClose}> 
                    {translator(messages.ok)}
                </Button>
            </ModalFooter>
        </ModalNext>
    )
}

export default InstallmentPreviewPopup;
